import CheckSquared from './CheckSquared'

export default CheckSquared
// eslint-disable-next-line import/export
export * from './CheckSquared'
